import { axios } from '@Root/API'

export const paginateReply = (id, params) => {
  return axios.get(`notes/${id}/children`, { params })
}
